export default __webpack_public_path__ + "static/media/Oro-1Open.468129a0.jpg";